import { getLogoImage } from '../../../utils/getLogoImage';
import * as styles from './LogoHeader.module.css';


const LogoHeader = () => (
  <div className={styles.header}>
    <img src={getLogoImage()} alt="logo" className={styles.fffLogo} data-testid="fff-logo" />
  </div>
);

export default LogoHeader;
